import { dateUtils, Ticket, translator } from '@parantion/components'
import MailService from '@/services/MailService'
import { Notify, uid } from 'quasar'
import {
  addStudentToNewGroup,
  checkTask,
  createForm,
  createTask,
  createTicket,
  createUser,
  deleteTicket,
  getFieldsForUserList,
  getFormsForGroup,
  getFormsForUser,
  getGroups,
  getStudentsOfGroup,
  getTasks,
  getTickets,
  getUserFields as ApiGetUserFields,
  memberOfGroups,
  removeStudentFromGroup,
  updateForm,
  updateTicket as apiUpdateTicket,
  updateUser as ApiUpdateUser
} from '@/services/APIService'

const { convertDateFormatToISO_8601 } = dateUtils

function showErrorToast(message) {
  Notify.create({ type: 'negative', icon: 'alarm_add', message })
}

export async function retrieveFormsFromUser({ commit, state, dispatch }, { uid, options }) {
  // if (state.userForms[uid] && (!options || !options.force)) return
  const forms = await getFormsForUser(uid)
  commit('ADD_FORMS_FOR_USER', { uid, forms })

  forms.forEach(form => {
    dispatch('retrieveTasks', { uh: uid, fh: form.fh })
  })

  // let promises = []
  // forms.forEach(form => {
  //   console.log('form', form)
  //   promises.push(getTemplateById(form.template).then(template => {
  //     console.log('template', template)
  //   }))
  // })
  //
  // await Promise.all(promises)
  // commit('ADD_FORMS_FOR_USER', {uid, forms})
}

export async function retrieveUsersFromGroups({ commit, state, dispatch }, { groupName, options }) {
  if (state.users[groupName] && (!options || !options.force)) {
    return
  }
  commit('SET_FETCHING_USERS', true)
  const users = await getStudentsOfGroup(groupName)
  await commit('ADD_USERS', { groupName, users })
  const uhList = users.map(user => user.uh).join(';')

  if (uhList.length > 0) {
    const usersWithFields = await getFieldsForUserList(uhList, ['gd_ibnaam', 'gd_ibemail', 'birthdate', 'status', 'created'])
      .then(res => res.map(user => {
        user = {
          ...user,
          ...user.field,
          status: user.field.status[0] ? user.field.status[0].value : 0
        }
        delete user.field
        return user
      }))

    commit('ADD_USERS', { groupName, users: usersWithFields })
  }

  commit('SET_FETCHING_USERS', false)
}

export async function getExtraUserFields({ state }) {
  const users = state.users
  console.log('users::', JSON.parse(JSON.stringify(state)))
  const promises = users.map((student) => ApiGetUserFields(student.uh).then(fields => {
    fields.status = fields.status[0].value
    student = Object.assign(student, fields)
  }))
  await Promise.all(promises)
  console.log('promises', JSON.parse(JSON.stringify(promises)))
}

export async function retrieveGroups({ commit, state }, options) {
  options = options || {}
  if (options.force || state.groups.length === 0) {
    const groups = await getGroups()


    commit('SET_GROUPS', groups)

    // for (let group of groups) {
    //   let promise = getStudentsOfGroup(group.name).then(users => {
    //     group.users = users
    //     group.users.forEach(u => {
    //       u.formCount = -1
    //       u.status = -1
    //     })
    //     commit('UPDATE_GROUP', group)
    //   })
    //   promisses.push(promise)
    // }
  }
}

export async function closeForm({ commit, state }, form) {
  try {
    await updateForm(form)
    commit('UPDATE_FORM', form)
  } catch (e) {
    console.error(e)
  }
}

export async function retrieveForms({ commit, state }, options) {
  options = options || {}
  if (options.force || state.forms.length === 0) {
    state.groups.forEach(group => {
      if (group.users) {
        group.users.forEach(u => {
          u.formCount = -1
          u.status = -1
        })
      }
    })
    // const forms = await getForms()
    const forms = await getFormsForGroup(options.group)
    commit('SET_FORMS', forms)
  }
}

export async function retrieveTasks({ commit, state }, options) {
  options = options || {}
  let forms
  if (options.uh) {
    forms = await checkTask(options.uh, options.fh)
  } else {
    console.warn('getTasks without uh can produce performance degradation')
    forms = await getTasks(options.fh)
  }
  commit('SET_TASKS', forms.tasks)
}

export async function retrieveTickets({ commit, state }) {
  // @ts-ignore
  const tickets = (await getTickets(state.student.uh)).map(t => new Ticket({
    fid: t.fh,
    tih: t.tih,
    email: t.strReceiverEmail,
    code: t.strAccesscode,
    write: t.intLinkType === '0',
    endDate: t.strEndDate,
    startDate: t.strStartDate,
    emailStatus: t.strEmailStatus
  }))
  commit('SET_TICKETS', tickets)
}

export async function deleteTickets({ commit }, ticket) {
  await deleteTicket(ticket.tih)
  commit('DELETE_TICKET', ticket.tih)
}

export async function updateTicket({ commit, rootState }, { fid, recipients, startDate, endDate, sendAgain, student, linkMail, codeMail }) {
  try {
    await recipients
      .map(recipient => ({
        tih: recipient.tih,
        strReceiverEmail: recipient.email,
        strAccesscode: recipient.code,
        intLinkType: recipient.write ? 0 : 1,
        strStartDate: startDate,
        strEndDate: endDate
      }))
      .map(ticket => apiUpdateTicket(ticket))

    recipients.forEach(ticket => {
      if (sendAgain) {
        MailService.sendTicketMail(ticket.tih, ticket.email, ticket.code, ticket.write, student, rootState.parantion.user.user, linkMail, codeMail)
      }
      // Need to set these manually
      ticket.fid = fid
      ticket.startDate = startDate
      ticket.endDate = endDate
      commit('UPDATE_TICKET', ticket)
    })
  } catch (e) {
    console.error(e)

    showErrorToast(`Kan deellink niet updaten: ${translator(e.response.data.message + '.error')}`)
  }
}

export async function createTickets({ commit, rootState }, { fid, recipients, startDate, endDate, student, linkMail, codeMail }) {
  try {
    const ticketPromises = recipients
      .map(recipient => ({
        fh: fid,
        uh: student.uh,
        type: 'form_access',
        strReceiverEmail: recipient.email,
        strAccesscode: recipient.code,
        intLinkType: recipient.write ? 0 : 1,
        strStartDate: startDate,
        strEndDate: endDate,
        tenant: 'gd 2.0'
      }))
      .map(ticket => createTicket(ticket))

    const result = await Promise.all(ticketPromises)
    result.forEach((task: any) => {
      MailService.sendTicketMail(task.ticketHash, task.recipient, task.code, task.write, student, rootState.parantion.user.user, linkMail, codeMail)
      // @ts-ignore
      commit('ADD_TICKET', new Ticket({
        fid,
        tih: task.ticketHash,
        code: task.code,
        write: task.write,
        email: task.recipient,
        endDate,
        startDate
      }))
    })
  } catch (e) {
    console.error(e)

    showErrorToast(`Kan deellink niet aanmaken: ${translator(e.response.data.message + '.error')}`)
  }
}

export async function addDocument({ commit, dispatch, rootState }, document) {
  try {
    document.frm_date_start = new Date()
    document.frm_date_start.setHours(12)
    document.frm_date_start = convertDateFormatToISO_8601(document.frm_date_start)
    const form = await createForm(document)
    document.fid = form.fh
    document.fh = document.fid
    document.uid = document.users[0]
    document.uh = document.uid
    document.tn = document.template
    document.frm_status = 1
    document.frm_date_created = Date.now()
    commit('ADD_FORM', document)
    dispatch('makeTicketForDocument', document)
  } catch (e) {
    showErrorToast(`Kan groeidocument niet aanmaken: ${translator(e + '.error')}`)
  }
}

export async function makeTicketForDocument({ commit, dispatch }, document) {
  commit('SET_TASK_PROGRESS', 0)
  let tasks
  try {
    tasks = (await checkTask(document.uh, document.fh)).tasks
    commit('SET_TASK_PROGRESS', 20)

    if (tasks.length === 0) {
      tasks = await createTask(document.fh, document.uh)
    }
    commit('SET_TASK_PROGRESS', 40)
    // Do not make a jailed_module_upload if it already exists
    const tempTicket = await getTickets(document.uh, 'jailed_module_upload')
    if (tempTicket.length === 0) {
      const ticket = {
        fh: document.fh,
        uh: document.uh,
        type: 'jailed_module_upload',
        blnHideShell: 0,
        blnIsModuleJail: 1,
        strStartUrl: '/user/portfolio/'
      }
      await createTicket(ticket)
    }

    commit('SET_TASK_PROGRESS', 70)

  } finally {
    await dispatch('retrieveTasks', { uh: document.uh, fh: document.fh })
    commit('SET_TASK_PROGRESS', 100)
  }
}

export async function changeStudentToGroup({ commit }, { student, currentGroups, newGroupNames }) {
  for (const newGroupName of newGroupNames) {
    if (!currentGroups.includes(newGroupName)) {
      await addStudentToNewGroup(student.uh, newGroupName)

      commit('RESET_USERS_FOR_GROUP', { groupName: newGroupName })
    }
  }

  for (const currentGroup of currentGroups) {
    if (!newGroupNames.includes(currentGroup)) {
      await removeStudentFromGroup(student.uh, currentGroup)
    }
  }
}

export async function addStudentToGroup({ commit, dispatch, rootState }, { student, groupName }) {
  student = Object.assign(student, {
    username: student.email + '_' + uid(),
    role: 'form_user;portfolio_student',
    group: groupName,
    agreement: true,
    status: student.status === 'active' ? 1 : 0
  })

  if (student.birthdate) {
    student.birthdate = new Date(student.birthdate)
    student.birthdate.setHours(12)
    student.birthdate = convertDateFormatToISO_8601(student.birthdate)
  } else delete student.birthdate

  try {
    const response = await createUser(student)
    student.uid = response.uh
    student.created = Date.now()
    student.formCount = 0

    commit('ADD_STUDENT_TO_GROUP', { student, groupName })
  } catch (e) {
    console.warn('error', e)
    showErrorToast(`Kan leerling niet aanmaken: ${translator(e.response.data.message + '.error')}`)
  }
}

export async function updateUser({ commit, dispatch, rootState }, { student, updatedFields }) {
  return ApiUpdateUser(student, updatedFields)
}

export async function getUserFields({ commit, dispatch, rootState }, uh) {
  return ApiGetUserFields(uh)
}

export async function getGroupsOfUser({ commit }, uh) {
  return memberOfGroups(uh)
}
